var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog-page" }, [
    _c(
      "div",
      { staticClass: "container py-4 blog-container" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { staticClass: "mb-3 mb-lg-0", attrs: { cols: "12", lg: "8" } },
              [
                _c("div", { staticClass: "page-intro card-shell mb-3" }, [
                  _c("h1", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.category_name))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "page-subtitle" }, [
                    _vm._v(
                      "Koleksi artikel tentang " +
                        _vm._s(_vm._f("lowercase")(_vm.category_name))
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.isSearching
                  ? _c(
                      "div",
                      { staticClass: "search-banner card-shell mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c("div", { staticClass: "search-label" }, [
                              _vm._v("\n              Hasil pencarian untuk "),
                              _c("strong", [
                                _vm._v('"' + _vm._s(_vm.searchQuery) + '"')
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "reset-btn",
                                attrs: {
                                  size: "sm",
                                  variant: "light",
                                  "aria-label": "Reset pencarian"
                                },
                                on: { click: _vm.reset }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: "times-circle",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProcessing
                  ? _c(
                      "div",
                      { staticClass: "card-shell p-3" },
                      [
                        _c(
                          "ContentLoader",
                          { attrs: { width: "100%", height: "420" } },
                          [
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "10",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "72"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "96",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "72"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "182",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "72"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "268",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "72"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "354",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "72"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : [
                      _vm.categoryPostList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "article-list" },
                            [
                              _vm._l(_vm.categoryPostList, function(
                                post,
                                index
                              ) {
                                return _c(
                                  "article",
                                  {
                                    key: index,
                                    staticClass: "card-shell article-card mb-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-start justify-content-between gap-2"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pr-2" },
                                          [
                                            _c(
                                              "b-link",
                                              {
                                                staticClass:
                                                  "article-title text-ip",
                                                attrs: { title: post.title },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goto(post)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(post.title) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "article-meta mt-2"
                                              },
                                              [
                                                post.date
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "meta-pill"
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon:
                                                                "calendar-alt",
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(post.date) +
                                                            "\n                    "
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "meta-pill" },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "eye",
                                                        "aria-hidden": "true"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          post.views || 0
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pagination-wrap mt-3" },
                                [
                                  _c("b-pagination-nav", {
                                    attrs: {
                                      "link-gen": _vm.linkGen,
                                      "number-of-pages": _vm.totalPage,
                                      "use-router": ""
                                    },
                                    on: { change: _vm.fetchCategoryPostList }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _c(
                            "div",
                            { staticClass: "card-shell p-4 empty-state" },
                            [
                              _c("h4", { staticClass: "mb-1" }, [
                                _vm._v("Belum ada artikel")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "Coba kategori lain atau gunakan pencarian untuk menemukan artikel yang Anda cari."
                                )
                              ])
                            ]
                          )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("b-col", { attrs: { cols: "12", lg: "4" } }, [
              _c(
                "div",
                { staticClass: "sidebar-block card-shell mb-3" },
                [
                  _c("h6", { staticClass: "sidebar-title" }, [
                    _vm._v("Cari Artikel")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchPost($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-group input-full-width" },
                        [
                          _c("b-input", {
                            attrs: {
                              type: "text",
                              placeholder: "Cari dalam kategori ini",
                              "aria-label": "Cari artikel"
                            },
                            model: {
                              value: _vm.searchQuery,
                              callback: function($$v) {
                                _vm.searchQuery = $$v
                              },
                              expression: "searchQuery"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group-append" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "search-btn",
                                  attrs: {
                                    type: "submit",
                                    variant: "primary",
                                    "aria-label": "Cari artikel"
                                  }
                                },
                                [_vm._v("Cari")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-block card-shell mb-3" }, [
                _c("h6", { staticClass: "sidebar-title" }, [
                  _vm._v("Kategori")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-wrap" },
                  [
                    _c(
                      "b-link",
                      {
                        staticClass: "category-chip all-chip",
                        attrs: { to: { name: "version2-blog-list" } }
                      },
                      [_vm._v("\n              Semua\n            ")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.category_list, function(category, index) {
                      return _c(
                        "b-link",
                        {
                          key: index,
                          staticClass: "category-chip",
                          class: {
                            "active-category":
                              category.text === _vm.category_name
                          },
                          on: {
                            click: function($event) {
                              return _vm.gotoCategory(category.text)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(category.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.latestPostList.length > 0
                ? _c("div", { staticClass: "sidebar-block card-shell" }, [
                    _c("h6", { staticClass: "sidebar-title" }, [
                      _vm._v("Artikel dalam Kategori")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "latest-list" },
                      _vm._l(_vm.latestPostList, function(post, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "latest-item",
                            class: {
                              "latest-item-border":
                                _vm.latestPostList.length - 1 !== index
                            }
                          },
                          [
                            _c(
                              "b-link",
                              {
                                staticClass: "latest-link text-ip",
                                on: {
                                  click: function($event) {
                                    return _vm.goto(post)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(post.title) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }